import type { ProjectDetail, ProjectDetailMeta } from "./project.type";
import type { UseGetOptions } from "@/hooks/queries";

import { useGet } from "@/hooks/queries";

export const useGetProject = (
  projectId?: number | string,
  options?: UseGetOptions<ProjectDetail, ProjectDetailMeta>
) => {
  const { data, meta, ...queryResult } = useGet<
    ProjectDetail,
    ProjectDetailMeta
  >("projects", projectId, options);

  return {
    project: data,
    context: meta?.context,
    ...queryResult,
  };
};
